import Sidebar from './Sidebar';
import { useUserStore } from '../store/userStore';
import LoadingScreen from './LoadingScreen';

interface LayoutProps {
  children: React.ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const user = useUserStore((state) => state.user);

  if (!user) {
    return <LoadingScreen />;
  }

  return (
    <div className="flex min-h-screen">
      <Sidebar
        user={{
          name: `${user.first_name} ${user.last_name}`,
          email: user.email,
        }}
      />
      <main className="flex-1">{children}</main>
    </div>
  );
}
